import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../utils/api';
import { TrendingUp, Loader2 } from 'lucide-react';

export default function Reports() {
  const [reports, setReports] = useState([]);
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [teamFilter, setTeamFilter] = useState('');

  const load = () => {
    setLoading(true);
    const query = {};
    if (teamFilter) query.team_id = teamFilter;
    Promise.all([api.getReports(query), api.getTeams()])
      .then(([r, t]) => { setReports(r.reports || []); setTeams(t.teams || []); })
      .finally(() => setLoading(false));
  };

  useEffect(load, [teamFilter]);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-navy-900">Report history</h1>
        <p className="text-gray-500 mt-1">Every Tactmark Analysis Engine report your organization has generated.</p>
      </div>

      <div className="flex flex-wrap gap-3 mb-6">
        <select value={teamFilter} onChange={(e) => setTeamFilter(e.target.value)}
          className="border border-gray-300 rounded-lg px-3 py-2 text-sm">
          <option value="">All teams</option>
          {teams.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
        </select>
      </div>

      {loading ? (
        <div className="text-center py-24"><Loader2 className="w-6 h-6 animate-spin mx-auto text-gray-500" /></div>
      ) : reports.length === 0 ? (
        <div className="text-center py-16 bg-white rounded-2xl border border-gray-200">
          <TrendingUp className="text-gray-400 w-12 h-12 mx-auto mb-4" />
          <p className="text-gray-500">No reports yet.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {reports.map((r) => (
            <Link key={r.id} to={`/analysis/${r.match_id}`}
              className="block bg-white border border-gray-200 rounded-2xl p-5 hover:border-navy-300 transition-colors">
              <div className="flex items-center justify-between mb-1">
                <p className="text-navy-900 font-medium">{r.report_title}</p>
                <span className="text-gray-400 text-xs">{new Date(r.created_at).toLocaleDateString()}</span>
              </div>
              <p className="text-gray-500 text-sm line-clamp-2">{r.verdict_summary}</p>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
